<template> </template>

<style></style>

<script>
export default {
	name: "resetpassword",
	components: {},
	created() {
		   this.$store.commit("showPopup", false);
		this.$store.commit("setloaderText", {
			show: true,
			text: "Verifing your email please wait and don't refresh The page",
		});
		this.idParamUid = this.$route.query.uid;
		this.idParamToken = this.$route.query.token;
		this.$store.commit("updateResetField", {
			type: "token",
			value: this.idParamToken,
		});
		this.$store.commit("updateResetField", {
			type: "email",
			value: this.idParamUid,
		});
		this.$store.commit("setloaderText", { show: false, text: "" });
		this.$router.push("/updatepassword-en/em/");
	},
	methods: {
		showViaPhone() {
			this.activeTabEmail = false;
			this.activeTabPhone = true;
		},
		showViaEmail() {
			this.activeTabPhone = false;
			this.activeTabEmail = true;
		},
		gotoSingUp() {
			this.$router.push("/signup");
		},
		emailFocus() {
			this.showEmailValid = false;
		},
		passwordFocus() {
			this.showPasswordValid = false;
		},
		gotoSingin() {
			this.$router.push("/signup");
		},
		resetpassword() {
			this.isActive = true;
			this.showresetpasswordErr = false;
			var self = this;
			if (this.doresetpassword) {
				var dataToSend = {
					password: this.password,
					uid: this.idParamUid,
					token: this.idParamToken,
				};

				this.$store.commit("setLoader", true);
				this.$store
					.dispatch("resetpassword", dataToSend)
					.then((res) => {
						this.showresetpasswordErr = true;
						this.resetpasswordErr = res.message;
						this.$store.commit("setLoader", false);
						setTimeout(function() {
							self.$router.push({ name: "resetpassword" });
						}, 5000);
					})
					.catch((err) => {
						this.$store.commit("setLoader", false);
						this.showresetpasswordErr = true;
						this.resetpasswordErr = err.response.data.error.message;
					});
			}
		},
	},

	data() {
		return {
			noService: false,
			activeTabEmail: true,
			textInputType: "password",
			activeTabPhone: false,
			showloginErr: false,
			loginErr: "",
			isActive: false,
			showresetpasswordErr: false,
			resetpasswordErr: "",
			isActive: false,
			doresetpassword: true,
			userid: "",
			password: "",
			repassword: "",
			idParamUid: "",
			idParamToken: "",
			bgImg: "https://www.ibakatv.com/_nuxt/img/62cf189.jpg",
		};
	},
};
</script>
